import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Instalaciones: React.FC = () => {
  const [instalaciones, setInstalaciones] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({ nombre: '', descripcion: '', costo: '' });

  const cargar = async () => {
    setLoading(true);
    try { const res = await api.get('/instalaciones'); setInstalaciones(res.data); } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrirModal = (p?: any) => {
    setEditando(p || null);
    setForm(p ? { nombre: p.nombre, descripcion: p.descripcion || '', costo: p.costo } : { nombre: '', descripcion: '', costo: '' });
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre || !form.costo) { alert('Nombre y costo son obligatorios'); return; }
    try {
      if (editando) await api.put(`/instalaciones/${editando.id}`, form);
      else await api.post('/instalaciones', form);
      setModal(false); cargar();
    } catch { alert('Error al guardar'); }
  };

  const eliminar = async (id: string) => {
    if (!window.confirm('¿Desactivar este tipo de instalación?')) return;
    try { await api.delete(`/instalaciones/${id}`); cargar(); } catch {}
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>🔧 Tipos de Instalación</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Costos de instalación para nuevos clientes</p>
        </div>
        <button onClick={() => abrirModal()}
          style={{ background:'#f59e0b', border:'none', color:'white', padding:'10px 20px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
          + Nuevo Tipo
        </button>
      </div>

      {loading ? <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div> :
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px,1fr))', gap:16 }}>
          {instalaciones.map(p => (
            <div key={p.id} style={{ background:'#1e293b', borderRadius:12, padding:20, border:`1px solid ${p.activo ? '#f59e0b33' : '#33415533'}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
                <div>
                  <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16 }}>{p.nombre}</div>
                  <div style={{ color:'#64748b', fontSize:12, marginTop:4 }}>{p.descripcion || 'Sin descripción'}</div>
                </div>
                <span style={{ background: p.activo ? '#22c55e22' : '#ef444422', color: p.activo ? '#22c55e' : '#ef4444', border:`1px solid ${p.activo ? '#22c55e44' : '#ef444444'}`, borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700 }}>
                  {p.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              <div style={{ color:'#f59e0b', fontSize:28, fontWeight:800, marginBottom:8 }}>
                S/. {Number(p.costo).toFixed(2)}
              </div>
              <div style={{ color:'#64748b', fontSize:11, marginBottom:16 }}>Cobro único al instalar</div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={() => abrirModal(p)}
                  style={{ flex:1, background:'#1d4ed822', border:'1px solid #1d4ed844', color:'#60a5fa', borderRadius:8, padding:'8px', cursor:'pointer', fontWeight:600, fontSize:13 }}>
                  ✏️ Editar
                </button>
                <button onClick={() => eliminar(p.id)}
                  style={{ flex:1, background:'#ef444411', border:'1px solid #ef444433', color:'#ef4444', borderRadius:8, padding:'8px', cursor:'pointer', fontWeight:600, fontSize:13 }}>
                  🗑️ Desactivar
                </button>
              </div>
            </div>
          ))}
          {instalaciones.length === 0 && (
            <div style={{ color:'#64748b', textAlign:'center', padding:48, gridColumn:'1/-1' }}>
              No hay tipos de instalación. Crea el primero.
            </div>
          )}
        </div>
      }

      {modal && (
        <div onClick={() => setModal(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:28, width:420, border:'1px solid #334155' }}>
            <h3 style={{ color:'#f1f5f9', margin:'0 0 20px' }}>{editando ? '✏️ Editar Instalación' : '🔧 Nueva Instalación'}</h3>
            {[
              { label:'Nombre', key:'nombre', type:'text', placeholder:'Ej: Instalación básica' },
              { label:'Descripción', key:'descripcion', type:'text', placeholder:'Descripción opcional' },
              { label:'Costo de instalación (S/.)', key:'costo', type:'number', placeholder:'0.00' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom:16 }}>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>{f.label}</label>
                <input value={(form as any)[f.key]} onChange={e => setForm({...form, [f.key]: e.target.value})}
                  type={f.type} placeholder={f.placeholder}
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14, boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ background:'#f59e0b11', border:'1px solid #f59e0b33', borderRadius:8, padding:'10px 14px', marginBottom:16 }}>
              <span style={{ color:'#f59e0b', fontSize:12 }}>💡 Este costo se cargará como factura al registrar un nuevo cliente</span>
            </div>
            <div style={{ display:'flex', gap:10, marginTop:8 }}>
              <button onClick={() => setModal(false)} style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:600 }}>Cancelar</button>
              <button onClick={guardar} style={{ flex:1, background:'#f59e0b', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Instalaciones;
